export const hexToHsl = (hex: string): string | null => {
  const normalized = hex.trim().replace('#', '');
  if (![3, 6].includes(normalized.length)) return null;

  const expand = (value: string) =>
    value.length === 1 ? parseInt(value.repeat(2), 16) : parseInt(value, 16);

  const r = expand(normalized.slice(0, normalized.length === 3 ? 1 : 2)) / 255;
  const g =
    expand(normalized.slice(normalized.length === 3 ? 1 : 2, normalized.length === 3 ? 2 : 4)) /
    255;
  const b =
    expand(normalized.slice(normalized.length === 3 ? 2 : 4, normalized.length === 3 ? 3 : 6)) /
    255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const delta = max - min;

  let h = 0;
  if (delta !== 0) {
    if (max === r) {
      h = ((g - b) / delta) % 6;
    } else if (max === g) {
      h = (b - r) / delta + 2;
    } else {
      h = (r - g) / delta + 4;
    }
  }

  h = Math.round(h * 60);
  if (h < 0) h += 360;

  const l = (max + min) / 2;
  const s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

  const sPct = Math.round(s * 100);
  const lPct = Math.round(l * 100);

  return `${h} ${sPct}% ${lPct}%`;
};
